






import { Vue, Component, Prop } from 'vue-property-decorator'
@Component
export default class LabItem extends Vue {
    /**
     * lableLeft 左侧内容
     * lableRight 右侧内容
     * size lab left宽度
     */
    @Prop() lableLeft!: string
    @Prop() lableRight!: string
    @Prop({ default: '80' }) size!: (string | number)
}
